import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { readMustChangePassword } from '@lib/auth/mustChangePassword'
import { ROUTES } from '@features/Login/constants'

export const Protected = () => {
  return <Outlet />
}

export const Route = createFileRoute('/_protected')({
  beforeLoad: async ({ context, location }) => {
    const isLoggedIn = await context.auth.strategy?.isLoggedIn()

    if (!isLoggedIn) {
      throw redirect({ to: '/' })
    }

    // An administrator-issued password must be replaced before anything else. The API enforces
    // this independently; this redirect only puts the user on the right screen rather than
    // letting them hit 403s everywhere.
    if (readMustChangePassword() && location.pathname !== ROUTES.SET_PASSWORD) {
      throw redirect({ to: ROUTES.SET_PASSWORD })
    }
  },
  component: () => <Protected />
})
